import styled from 'styled-components'
import css from '@styled-system/css'
import { FieldError } from 'ui/acro'

const AccountLocationError = styled(FieldError)(() =>
  css({
    margin: '10px 0',
    p: {
      lineHeight: '1.2'
    }
  })
)

export default AccountLocationError
